import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { BackButton, LoadingState } from '../components/common';
import { Heading, Text } from '../components/common/Typography';
import { Card } from '../components/common/Card';
import { navigateBack } from '../utils/navigationUtils';
import { useClubPermissions } from '../hooks/useClubPermissions';
import { APP_PAGE_BLEED_ROOT, APP_PAGE_GUTTER } from '../utils/sessionMobileLayout';
import PasteAliasManager from '../components/clubs/PasteAliasManager';

const PasteAliasManagementPage = ({ currentUser }) => {
  const { clubId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    club: selectedClub,
    role: userClubRole,
    loading: clubLoading,
    hasPermission,
    error: clubError,
  } = useClubPermissions(clubId, currentUser);

  const canManage =
    ['owner', 'admin', 'host'].includes(userClubRole) ||
    currentUser?.role === 'admin' ||
    currentUser?.role === 'super_admin';

  const fromPlanSessions = Boolean(location.state?.fromPlanSessions);

  if (clubLoading) {
    return (
      <div className={`${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`}>
        <div className={`mx-auto max-w-app-shell ${APP_PAGE_GUTTER} py-12`}>
          <LoadingState message="Loading spreadsheet names…" />
        </div>
      </div>
    );
  }

  if (clubError || !hasPermission || !canManage) {
    return (
      <div className={`${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`}>
        <div className={`mx-auto max-w-app-shell ${APP_PAGE_GUTTER} py-12`}>
          <Card variant="default" size="large" className="text-center py-12">
            <Heading level={2} className="mb-4">Access Denied</Heading>
            <Text className="text-text-secondary">
              {clubError || 'Only club hosts, admins, and owners can edit spreadsheet names.'}
            </Text>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className={`${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`}>
      <div className={`mx-auto max-w-app-shell ${APP_PAGE_GUTTER} pt-3 pb-8 md:pt-6`}>
        <div className="mb-6">
          <BackButton
            onClick={() => {
              if (fromPlanSessions) {
                navigate(`/club/${clubId}/sessions`, { state: location.state });
                return;
              }
              navigateBack(navigate, location, clubId, `/club-management/${clubId}`);
            }}
          >
            {fromPlanSessions ? 'Back to Plan sessions' : 'Back to Club Management'}
          </BackButton>
          {selectedClub?.name ? (
            <Text className="mt-3 text-sm text-text-secondary">{selectedClub.name}</Text>
          ) : null}
        </div>
        <PasteAliasManager clubId={clubId} />
      </div>
    </div>
  );
};

export default PasteAliasManagementPage;
